export default [
  { type: "petrol", alias: ["petrol", "benzina"] },
  { type: "diesel", alias: ["diesel"] },
  { type: "natural_gas", alias: ["methan", "metano"] },
  { type: "LPG", alias: ["LPG", "gpl"] },
  { type: "hybrid", alias: ["hybrid", "ibrida"] },
  { type: "other", alias: ["other", "elettrica", "altro"] }
];



// WEBPACK FOOTER //
// ./src/stores/vehicleInformationStore/data/fuelTypes.js